// Centralized rubric text for the 5-parameter scoring system.
// Each entry describes how raw scores map to qualitative bands so that
// UI components can render consistent explanations.

const SCORE_RUBRICS = {
  keyResponsibilitiesMatch: {
    title: 'Key Responsibilities',
    ranges: [
      {
        range: '0–10',
        description: 'Most core duties from the JD are missing or only weakly reflected in the resume.',
      },
      {
        range: '11–25',
        description:
          'Partial overlap: some day-to-day tasks match, but several important responsibilities are not covered.',
      },
      {
        range: '26–38',
        description:
          'Strong overlap: most of the core responsibilities and workflows described in the JD appear in recent roles.',
      },
      {
        range: '39–45',
        description:
          'Excellent match: responsibilities very closely mirror the JD, including core duties and supporting tasks.',
      },
    ],
  },

  experienceAndLevel: {
    title: 'Experience & Level',
    ranges: [
      {
        range: '0–5',
        description:
          'Years of experience and seniority are well below what the JD calls for, or mostly in unrelated roles.',
      },
      {
        range: '6–15',
        description:
          'Partially aligned: experience is in the right ballpark but either a bit light or somewhat above the target band.',
      },
      {
        range: '16–22',
        description:
          'Strong alignment: years of experience and role level are a good fit for the JD’s expectations.',
      },
      {
        range: '23–25',
        description:
          'Very strong match or slightly over-qualified, but still appropriate for the seniority level of the role.',
      },
    ],
  },

  impactAchievements: {
    title: 'Impact & Achievements',
    ranges: [
      {
        range: '0–3',
        description:
          'Little or no concrete evidence of outcomes; bullets mostly describe duties without measurable results.',
      },
      {
        range: '4–7',
        description:
          'Some specific achievements are present, but metrics or clear business impact are limited or sporadic.',
      },
      {
        range: '8–12',
        description:
          'Good track record of outcome-focused achievements with a mix of quantified and well-scoped examples.',
      },
      {
        range: '13–15',
        description:
          'Exceptional impact with multiple strong, quantified achievements and clear ownership over results.',
      },
    ],
  },

  careerTrajectory: {
    title: 'Career Trajectory',
    ranges: [
      {
        range: '0–1',
        description:
          'Trajectory or stability concerns: frequent short stints, unclear progression, or steps backwards in scope.',
      },
      {
        range: '2–3',
        description:
          'Reasonable trajectory: generally stable roles with some growth, though progression may be modest or mixed.',
      },
      {
        range: '4–5',
        description:
          'Strong trajectory and stability with clear progression in scope/seniority and solid tenure in key roles.',
      },
    ],
  },

  educationCredentials: {
    title: 'Education & Credentials',
    ranges: [
      {
        range: '0–2',
        description: 'Education or credentials are clearly unrelated to the JD’s domain or requirements.',
      },
      {
        range: '3–5',
        description:
          'Generic or partially relevant education; meets a basic degree requirement but not closely targeted.',
      },
      {
        range: '6–8',
        description:
          'Relevant education aligned with the JD (e.g., matching field or strongly adjacent degree/credential).',
      },
      {
        range: '9–10',
        description:
          'Directly matching degree or specialization (e.g., the exact field or credential the JD explicitly asks for).',
      },
    ],
  },
};

export default SCORE_RUBRICS;

